<template>
    <div class="admin__exports">
        <h5 class="admin__exports-title"><i class="far fa-file-csv"></i> Export Opt-Out Information</h5>
        <div class="row">
            <div class="col-xl-10">
                <p class="admin__exports-subtitle">Download/export relevant Student Choice Initiative opt-out data</p>
                <div class="row">
                    <div class="col-lg-5">
                        <label><i class="far fa-books"></i> Academic Year</label>
                    </div>
                    <div class="col-lg-7">
                        <div v-if="filesFlag" class="input-group input-group-sm">
                            <select class="form-control" id="academicYear" name="academicYear" ref="academicYear"
                                @change="setExportLink">
                                <option v-if="!exportLink" selected disabled>Select an academic year</option>
                                <option v-for="item in files" :value="item.yearStart" :key="item.file">{{ item.label }}
                                </option>
                            </select>
                            <div class="input-group-append">
                                <button v-if="!exportLink" type="button" class="btn btn-outline-secondary" disabled>
                                    <i class="far fa-download" :disabled="!exportLink"></i>
                                    Export
                                </button>
                                <a v-else :href="exportLink" class="btn btn-primary"><i class="far fa-download"
                                        :disabled="!exportLink"></i>
                                    Export</a>
                            </div>
                        </div>
                        <div v-else class="text-primary">
                            <i class="far fa-bells"></i> There are currently no files that can be exported. If there are
                            any questions or concerns, <b>please contact your system administrator.</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'admin-exports',
    props: {
        files: {
            type: Array
        }
    },
    data() {
        return {
            exportLink: '',
            filesFlag: false
        }
    },
    methods: {
        hasExports() {
            if (this.files && this.files.length > 0) {
                this.filesFlag = true;
            } else {
                this.filesFlag = false;
            }
        },
        setExportLink() {
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminExport';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Academic year handler
            if (this.$refs.academicYear && this.$refs.academicYear.value) {
                URL = URL + '&yearStart=' + this.$refs.academicYear.value;
            }

            // Set export link
            this.exportLink = URL;
        }
    },
    mounted() {
        // Initial exports file check
        this.hasExports();
    }
}
</script>

<style scoped>
.admin__exports {}

.admin__exports-title {
    color: #455a64;
    font-weight: 400;
}

.admin__exports-subtitle {
    font-weight: 300;
    margin-bottom: 15px;
    color: #99abb4;
}
</style>